
import { useState, useEffect, useCallback } from 'react';
import useTaskFileUploader from '../../../../customHook/useTaskFileUpload';

export const useTaskFiles = (attachments?: File[] | string[] | null, onUploadComplete?: (urls: string[]) => void) => {
  const getAttachmentsArray = (attachments?: File[] | string[] | null | { added?: any[]; removed?: any[] }): (File | string)[] => {
    if (!attachments) return [];
    
    if (typeof attachments === 'object' && !Array.isArray(attachments) && 'added' in attachments) {
      return Array.isArray(attachments.added) ? [...attachments.added] : [];
    }
    
    if (Array.isArray(attachments)) {
      return [...attachments];
    }
    
    return [];
  };

  const [selectedFiles, setSelectedFiles] = useState<(File | string)[]>(
    getAttachmentsArray(attachments)
  );
  const [uploadedUrls, setUploadedUrls] = useState<string[]>([]);
  const { uploadTaskFiles } = useTaskFileUploader();
  const Email = sessionStorage.getItem('current-user') || '';

  useEffect(() => {
    setSelectedFiles(getAttachmentsArray(attachments));
  }, [attachments]);

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    const fileNames = acceptedFiles.map(f => f.name);
    setSelectedFiles((prev) => [...prev, ...acceptedFiles]);
    try {
      const urls = await uploadTaskFiles(acceptedFiles, Email);
      if (urls.length > 0) {
        setUploadedUrls((prev) => [...prev, ...urls]);
        setSelectedFiles((prev) => {
          const existingFiles = prev.filter((item) => {
            if (item instanceof File) {
              return !fileNames.includes(item.name);
            }
            return true;
          });
          return [...existingFiles, ...urls];
        });
        onUploadComplete?.(urls);
      }
    } catch (err) {
      setSelectedFiles((prev) => 
        prev.filter((item) => {
          if (item instanceof File) {
            return !fileNames.includes(item.name);
          }
          return true;
        })
      );
    }
  }, [Email, uploadTaskFiles, onUploadComplete]);

  const deleteFile = useCallback(
    (index: number) => {
      setSelectedFiles(selectedFiles.filter((_, ind) => ind !== index));
      setUploadedUrls(uploadedUrls.filter((_, ind) => ind !== index));
    },
    [selectedFiles, uploadedUrls]
  );

  const resetFiles = useCallback(() => {
    setSelectedFiles(getAttachmentsArray(attachments));
    setUploadedUrls([]);
  }, [attachments]);

  return {
    selectedFiles,
    setSelectedFiles,
    onDrop,
    deleteFile,
    resetFiles,
    uploadedUrls,
  };
};
